<template>
  <div class="courses-wrap">
    <div class="courses-content">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :lg="17" :xl="17">
          <div class="courses-left">
            <div class="courses-box">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :lg="13">
                  <div class="img-auto"><img :src="course.imgUrl" width="680" height="382" /></div>
                </el-col>
                <el-col :xs="24" :sm="24" :lg="11">
                  <div class="info">
                    <div class="title">{{course.name}}</div>
                    <div class="keyword">
                      <el-row :gutter="20">
                        <template v-for="label in labels">
                          <el-col :xs="8" :sm="8" :lg="6"><span class="k-item">{{label}}</span></el-col>
                        </template>
                      </el-row>
                    </div>
                    <div class="num-people">{{course.learnNum}}人在学习</div>
                    <div class="price">
                      <i>￥</i>
                      {{course.price}}
                    </div>
                    <div class="btn">
                      <el-row :gutter="10">
                        <el-col :xs="12" :sm="6" :lg="8"><a href="http://p.qiao.baidu.com/cps/chat?siteId=14288848&userId=25748740" target="_blank" class="col-btn btn01">在线报名</a></el-col>
                        <el-col :xs="12" :sm="6" :lg="8"><a href="http://p.qiao.baidu.com/cps/chat?siteId=14288848&userId=25748740" target="_blank" class="col-btn btn02">认证培训</a></el-col>
                      </el-row>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <div style="clear: both;"></div>
            </div>
            <div class="courses-info">
              <div class="hd">
                <el-row :gutter="10">
                  <el-col class="hd-item" :xs="8" :sm="8" :lg="3"><a href="javascript:;" @click="current = 0" :class="{ hover: current == 0 }">课程介绍</a></el-col>
                  <el-col class="hd-item" :xs="8" :sm="8" :lg="3"><a href="javascript:;" @click="current = 1" :class="{ hover: current == 1 }">课程目录</a></el-col>
                  <el-col class="hd-item" :xs="8" :sm="8" :lg="3"><a href="javascript:;" @click="current = 2" :class="{ hover: current == 2 }">技能考试</a></el-col>
                </el-row>
              </div>
              <div class="bd">
                <div class="item" v-show="current == 0" v-html="course.contentIntroduce"></div>
                <div class="item" v-show="current == 1" v-html="course.contentCatalog"></div>
                <div class="item" v-show="current == 2" v-html="course.contentOther"></div>
              </div>
            </div>
            <div class="rec-materials">
              <div class="common-hd">推荐教材</div>
              <div class="rec-m-box">
                <el-row :gutter="20">
                  <template v-for="(item,index) in recommends">
                    <el-col :xs="24" :lg="12">
                    <a :href="'/teachingMaterial/'+item.id">
                    <div class="item">
                      <div class="img"><img :src="item.imgUrl"  width="160" height="230"/></div>
                      <div class="info">
                        <div class="title">{{item.name}}</div>
                        <div class="desc">{{item.description}}</div>
                        <div class="price">
                          <span class="span01">
                            <template v-if="item.price != null">
                              ￥{{item.price}}
                            </template>
                            <template v-else>
                              价格待定
                            </template>
                          </span>
                          <span class="span02">
                            {{item.learnNum}}
                            <template v-if="item.price != null">
                              人已购买
                            </template>
                            <template v-else>
                              人已预定
                            </template>
                          </span>
                        </div>
                      </div>
                    </div>
                    </a>
                  </el-col>
                  </template>
                </el-row>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="7" :xl="7">
          <div class="courses-right">
            <!--精品课程推荐-->
            <div class="rec-courses">
              <h2>精品课程推荐</h2>
              <ul>
                <template v-for="(item,index) in boutiques">
                <li>
                  <a :href="'/paidCourses/'+item.id" :class="item.id == id ? 'hover' : ''">
                    <i></i>
                    {{item.name}}
                  </a>
                </li>
                </template>
              </ul>
            </div>
            <div class="college">
              <div class="c-hd">现代物业（精装12期）</div>
              <div class="bd">
                <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/zazhi.png"></div>
                <p>弘范智汇是面向广大清洁从业者的学习平台，为从业者提供理论知识、技能实操、专业认证优质课程内容。</p>
                </div>
              <div class="btn"><a href="http://p.qiao.baidu.com/cps/chat?siteId=14288848&userId=25748740" target="_blank" class="btn-gray">联系客服购买</a></div>
            </div>
            <div class="college">
              <div class="c-hd">弘范学院</div>
              <div class="bd"><p>弘范智汇是面向广大清洁从业者的学习平台，为从业者提供理论知识、技能实操、专业认证优质课程内容。</p></div>
              <div class="btn"><a href="http://p.qiao.baidu.com/cps/chat?siteId=14288848&userId=25748740"  target="_blank">认证培训</a></div>
            </div>
            <!--商业合作-->
            <div class="college">
              <div class="c-hd">商业合作</div>
              <div class="bd"><p>请扫码加入清洁培训交流群</p></div>
              <div class="qcode"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/about/qcode.png" width="200" height="200" /></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: 0,
      path: domain.apiUrl,
      id : this.$route.params.id,
      course: {},//详情
      labels: [],//标签
      boutiques: [],//精品课程
      recommends: [],//推荐教材
    }
  },
  created() {
    this.paidCourses();
  },
  methods: {
    paidCourses: function() {
      let formData = {};
      formData.id = this.id;
      this.$http.get(this.path + '/course/course',{params:formData}).then((response) => {
        if (response.status === 200) {
          var data = response.body;
          this.course = data.course;
          this.boutiques = data.boutiques;
          this.recommends = data.recommends;

          this.labels = this.course.labels.replace(/；/g , "；").split("；");
        }
      }, (response) => {
        this.$message.error("error")
      });
    },


  },
};
</script>

<style lang="scss">
@import '../assets/css/paidcourses.scss';
</style>



// WEBPACK FOOTER //
// src/components/paidCourses.vue